export const answeredCoursesSearchSettings = {
  limit: 20,
  offset: 20,
};
export const csvSearchLimitSettings = {
  limit: 1000,
  offset: 0,
};
